export interface OrderItemVendorConstructor {
  id: number
  name: string
  isAutoEmailPoEnabled: boolean
  active: boolean
}

export class OrderItemVendor {
  id: number
  name: string
  isAutoEmailPoEnabled: boolean
  active: boolean

  constructor(data: OrderItemVendorConstructor) {
    this.id = data.id
    this.name = data.name
    this.isAutoEmailPoEnabled = data.isAutoEmailPoEnabled
    this.active = data.active
  }

  get isOtherVendor() {
    return this.id === 1
  }
}
